<template id="nbrResultats">
  <div class="info-recherche" aria-live="polite" role="status" :aria-label="ariaLabelNbrResultat + formateurs.length">
	  <p class="total-results" v-if="!isFetching">{{ formateurs.length != 0 ? formateurs.length + " éléments" : "Aucun résultat pour cette recherche"  }}</p>
  </div>
</template>


<script>
  export default {
    name:"NombreResultatAfficher",
    props: {
	    nbrResultats: {
          type: Number
	    },
	    formateurs: {
          type: Array
	    },
      isFetching: {
        type: Boolean
      }
	},
    data(){
      return{
          ariaLabelNbrResultat:"Nombre de résultats de recherche "
      }
    }, 
    methods:{
      
    },
    computed: {
     
    }
  }
</script>

<style scoped>

</style>